import { render, staticRenderFns } from "./transactionDetails.vue?vue&type=template&id=55410143&scoped=true"
import script from "./transactionDetails.vue?vue&type=script&lang=ts"
export * from "./transactionDetails.vue?vue&type=script&lang=ts"
import style0 from "./transactionDetails.vue?vue&type=style&index=0&id=55410143&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55410143",
  null
  
)

export default component.exports